<template>
    <div>
        <app-form 
            v-bind:parentObject = "{
                data: this.formData,
                dataParameter: this.formDataParameter,
                parameters: this.parameters,
                staffList: this.staffList,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import KpiSettingForm from '../../../components/performancemanagement/targetsetting/Form_Parameter';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': KpiSettingForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('performancemanagement.kpisettingfor'),
            pageTitleValue: this.$route.params.formData.kpiexercode,

            formData: this.$route.params.formData,
            formDataParameter: this.$route.params.formDataParameter,
            parameters: this.$route.params.parameters,

            staffList: [],
            statusList: [],

            errMsg: '',
            isErr:false,
            editMode: this.$route.params.isEdit, 
        }
    },
}

</script>